import {getImagePreviewURL} from "../page/yard/recovery/api";

export const drawer = {

  /**
   * 页面类型
   */
  pageType: {//侧边栏类型
    dtOriginal: 'dt_oo',    //原单差异搜索
    dtCollusionSo: 'dt_co_so',  //串货，搜索订单
    dtCollusionSku: 'dt_co_sku', //串货，搜索SKU
    dtWhole: 'dt_wb' //整箱差异搜索
  },

  /**
   * 数据上报类型
   */
  dataReportType: {//差异上报类型（original-order：原单差异，collusion-order：串货差异，whole-box：整箱差异）
    original: 'original-order',
    collusion: 'collusion-order',
    whole: 'whole-box',
    isShowButton: function(dataTicketType) { //后台数据记录的类型
      return this.isCollusionData(dataTicketType);
    },
    isCollusionData: function(dataTicketType) { //是否未串货数据
      if (dataTicketType == 'collusion-order') {
        return true;
      }
      return false;
    },
    getDiffTypeNo: function(diffTypeName) {
      if (diffTypeName == '原单差异') {
        return this.original;
      } else if (diffTypeName == '串货差异') {
        return this.collusion;
      } else {
        return this.whole;
      }
    }
  }
}

export const locationText = (code) => {
  let text = '';
  switch(code){
    case 'left':
      text = '车辆左侧';
      break;
    case 'right':
      text = '车辆右则';
      break;
    case 'inner':
      text = '车辆内部';
      break;
    case 'signature':
      text = '签名';
      break;
    case 'commissionForm':
      text = '电子委托单';
      break;
    case 'location':
      text = '地点';
      break;
    case 'loading':
      text = '装车';
      break;
    case 'other':
      text = '其他';
      break;
    case 'sealingLead':
      text = '封铅';
      break;
    case 'containerNumber':
      text = '集装箱号';
      break;
    case 'containerBottom':
      text = '集装箱底部';
      break;
    case 'containerLeft':
      text = '集装箱左侧';
      break;
    case 'containerRight':
      text = '集装箱右侧';
      break;
    case 'containerTop':
      text = '集装箱顶部';
      break;
  }
  return text;
}



// WEBPACK FOOTER //
// ./src/utils/constant.js